module.exports = __webpack_public_path__ + "img/logo-vrjmof2024_white.48812b8b.svg";